import {VeBoxCard} from "../../../components/card/VeBoxCard";
import * as React from "react";
import {ProgressBar} from "../../../components/ProgressBar";
import {Display} from "../../../components/Display";
import {getStatusColor, STATUS_TEXTS, StatusChip} from "../../components/StatusChip";
import "./styles.scss"
import {Theme} from "@vebox/etui-themes";
import {useTheme} from "@vebox/etui-system";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";

interface UpdatingConfigurationProgressBarProps {
    count: number
    total: number
    updatingFrom: string
    user: string,
    errorsLabel: string
}

export const UpdatingConfigurationProgressBar: React.FC<UpdatingConfigurationProgressBarProps> = ({
                                                                                                      updatingFrom,
                                                                                                      total,
                                                                                                      user,
                                                                                                      count,
                                                                                                      errorsLabel
                                                                                                  }) => {
    const {AppTranslations} = React.useContext(ReadAndWriteContext);
    const getText = () => AppTranslations.readAndWrite.configurationStartedAt.replace("{0}", updatingFrom)
        .replace("{1}", user);
    const theme = useTheme();
    return (
        <VeBoxCard className={"rw-card"}>
            <VeBoxCard.Body className={"rw-card-body"}>
                <div className={"flx-row flx-space-between"}>
                    <h2 className={"progress-bar-title"}>{AppTranslations.readAndWrite.updatingConfiguration} {count}/{total}</h2>
                    <div className={"chip-container"}>
                        <Display isVisible={errorsLabel !== ""}>
                            <StatusChip status={STATUS_TEXTS.ERROR} customLabel={errorsLabel}/>
                        </Display>
                        <Display isVisible={count === total && total !== 0}>
                            <StatusChip status={STATUS_TEXTS.COMPLETED}/>
                        </Display>
                        <Display isVisible={count !== total}>
                            <StatusChip status={STATUS_TEXTS.IN_PROGRESS}/>
                        </Display>
                    </div>
                </div>
                <ProgressBar
                    bgColor={getStatusColor(STATUS_TEXTS.IN_PROGRESS, theme as Theme)}
                    value={count ?? 0}
                    max={total ?? 0}
                />
                <div className={"flx-row flx-space-between"}>
                    <p className={"progress-bar-footer-info"}>{getText()}</p>
                    <p className={"progress-bar-footer-info"}>{AppTranslations.readAndWrite.updatingOnDeviceCommunication}</p>
                </div>
            </VeBoxCard.Body>
        </VeBoxCard>
    );
};
